<div #graph id="graph"  [ngClass]="{'graph-opacity': isSimulationsLessThan50}"></div>
<div #customMenuList class="customMenuList">
  <div class="dropdown">
    <ul class="dropdown-content">
      @if (menuDataSet.includes('navigate')) {
        <button tabindex="0" aria-label="Drill In" (click)="menuEvent('navigate')">
          <mds-icon [key]="icons.DRILL_IN" [width]="20" [height]="20" [pathColors]="['#547080']"></mds-icon>
          <div>Drill In</div>
        </button>
      }
      @if (menuDataSet.includes('substitute')) {
        <button tabindex="0" aria-label="Substitute" (click)="menuEvent('substitute')">
          <mds-icon [key]="icons.PIN" [width]="20" [height]="20" [pathColors]="['#547080']"></mds-icon>
          <div>Substitute</div>
        </button>
      }
      @if (menuDataSet.includes('edit')) {
        <button tabindex="0" aria-label="edit" (click)="menuEvent('edit')">
          <mds-icon [key]="icons.EDIT" [width]="20" [height]="20" [pathColors]="['#547080']"></mds-icon>
          <div>Edit</div>
        </button>
      }
      @if (menuDataSet.includes('edit') && showEditOriginal) {
        <button  tabindex="0" aria-label="Edit Original"  (click)="menuEvent('editOriginal')">
          <mds-icon [key]="icons.EDIT_ORIGINAL" [width]="20" [height]="20" [pathColors]="['#547080']"></mds-icon>
          <div>Edit Original</div>
        </button>
      }
      @if (menuDataSet.includes('savepng')) {
        <button  tabindex="0" aria-label="Save" (click)="menuEvent('savepng')">
          <mds-icon [key]="icons.DOWNLOAD" [width]="20" [height]="20" [pathColors]="['#547080']"></mds-icon>
          <div>Save</div>
        </button>
      }
      @if (menuDataSet.includes('todo')) {
        <button tabindex="0" aria-label="To-Do"  (click)="menuEvent('todo')">
          <mds-icon [key]="icons.ADD_TODO" [width]="20" [height]="20" [pathColors]="['#547080']"></mds-icon>
          <div>To-Do</div>
        </button>
      }
    </ul>
  </div>
</div>
